import { Box } from '@mui/material';
import Table from '../../../core-components/theme/components/Table/Table';
import { columns } from '../helper/tableHelper';
import { useLogbookTable } from '../hooks/useLogbookListTable';

export default function LogbookListTable({ searchString }: any) {
    const { logbooks, lastElementRef, tableContainerRef, queryKey } = useLogbookTable(searchString);

    return (
        <Box ref={tableContainerRef} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Table
                stickyHeader
                rows={logbooks}
                columns={columns(queryKey) as any}
                lastRowRef={lastElementRef as any}
            />
        </Box>
    );
}